module.exports = __webpack_public_path__ + "img/banner-3.1755b597.png";